function OutputDate({field, object}) {
    const value = object[field];
    if (value) {
        // Extract year, month, and day assuming format is YYYY-MM-DD
        const [year, month, day] = value.split('-');
        // Create a mapping of month numbers to month names
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const formattedDate = `${monthNames[parseInt(month, 10) - 1]} ${parseInt(day, 10)}, ${year}`;
        return formattedDate;
    }
    return null;
}

export default OutputDate;
